import { NgModule } from '@angular/core';
import { MapStatusPipe } from './map-status.pipe';

@NgModule({
  declarations: [MapStatusPipe],
  exports: [MapStatusPipe],
})
export class AssetPipesModule {}
